import { render, staticRenderFns } from "./photo-material.vue?vue&type=template&id=5cf09037&scoped=true&"
import script from "./photo-material.vue?vue&type=script&lang=js&"
export * from "./photo-material.vue?vue&type=script&lang=js&"
import style0 from "./photo-material.vue?vue&type=style&index=0&id=5cf09037&scoped=true&lang=scss&"
import style1 from "./photo-material.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf09037",
  null
  
)

export default component.exports